exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gitlab-oauth-screen .v-content {\n  display: flex;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n}\n.gitlab-oauth-screen .v-content__wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n", ""]);

// exports
